// Capitaliza nombres propios: primera letra de cada palabra en mayúscula y el
// resto en minúscula. Normaliza también nombres escritos TODO EN MAYÚSCULAS o
// todo en minúsculas. Las partículas comunes en español (de, del, la, los, y…)
// quedan en minúscula salvo que sean la primera palabra, para que quede natural
// (ej: "María de los Ángeles", "Juan de la Cruz").
const PARTICULAS = new Set([
  "de", "del", "la", "las", "los", "y", "e", "da", "das", "do", "dos",
  "van", "von", "di", "el",
]);

export function capitalizarNombre(texto) {
  const limpio = String(texto || "").trim().replace(/\s+/g, " ");
  if (!limpio) return "";

  return limpio
    .split(" ")
    .map((palabra, i) => {
      const min = palabra.toLowerCase();
      // Partículas en minúscula, salvo la primera palabra del nombre.
      if (i > 0 && PARTICULAS.has(min)) return min;
      // Respeta guiones internos (ej: "Ana-María") capitalizando cada parte.
      return min
        .split("-")
        .map((parte) => (parte ? parte.charAt(0).toUpperCase() + parte.slice(1) : parte))
        .join("-");
    })
    .join(" ");
}
